import './SearchForm.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchInput from '../components/SearchInput';
import InfoBox from '../components/InfoBox';
import fetchManufacturers from '../actions/fetch_manufacturers';
import fetchFacet from '../actions/fetch_facet';
import selectFacet from '../actions/select_facet';
import selectProduct from '../actions/select_products';
import clearFacet from '../actions/clear_facet';
import clearProducts from '../actions/clear_products';
import fetchProducts from '../actions/fetch_products';
import FACET_CODES from '../constants/facetCodes';
import LoadingIndicator from '../components/LoadingIndicator';
import SearchResult from '../components/SearchResult';
import PRODUCT_CODES from '../constants/productCodes';
import { Button } from 'antd';
import { withRouter } from 'react-router-dom';
import { withLocalize, Translate, getTranslate } from 'react-localize-redux';
import { detect } from 'detect-browser';

class SearchForm extends Component {
  constructor(props) {
    super(props);

    this.onChangeManufacturer = this.onChangeManufacturer.bind(this);
    this.onChangeChuckType = this.onChangeChuckType.bind(this);
    this.onChangeChuckSize = this.onChangeChuckSize.bind(this);
    this.onChangeChuckDetail = this.onChangeChuckDetail.bind(this);
    this.onProductsSelection = this.onProductsSelection.bind(this);
    this.resetSearch = this.resetSearch.bind(this);

    this.resizeFrameToInitial = this.resizeFrameToInitial.bind(this);
    this.scrollFrameToInitial = this.scrollFrameToInitial.bind(this);
    this.resizeFrameToFit = this.resizeFrameToFit.bind(this);

    const browser = detect();
    this.state = {
      defaultItem: {
        name: this.props.translate('SearchForm_PleaseSelect'),
        code: 'unselected'
      },
      browser: browser
    };
  }

  componentDidMount() {
    if (this.props.manufacturers.length === 0) {
      this.props.fetchManufacturers(this.props.locale);
    }
  }

  resetSearch(e) {
    this.props.clearProducts(PRODUCT_CODES.PRODUCTS);
    this.props.clearFacet(FACET_CODES.CHUCK_DETAIL);
    this.props.clearFacet(FACET_CODES.CHUCK_SIZE);
    this.props.clearFacet(FACET_CODES.CHUCK_TYPE);
    this.props.selectFacet('', FACET_CODES.MANUFACTURER);

    this.resizeFrameToInitial();
    this.scrollFrameToInitial();
  }

  resizeFrameToFit() {
    if ('parentIFrame' in window) {
      var scrollHeight = document.getElementById('root').scrollHeight;
      console.log('Resizing to ' + scrollHeight);
      //window.parentIFrame.size(scrollHeight);
    }
  }

  resizeFrameToInitial() {
    if ('parentIFrame' in window) {
      console.log('Resizing to 400');
      window.parentIFrame.size(450);
    }
  }

  scrollFrameToInitial() {
    if ('parentIFrame' in window) {
      console.log('Scrolling to Frame');
      window.parentIFrame.scrollToOffset(0, 0);
    }
  }

  onChangeManufacturer(value) {
    if (!value || value === 'unselected') {
      return;
    }
    if (this.props.selectedManufacturer !== '') {
      this.props.clearFacet(FACET_CODES.CHUCK_TYPE);
      this.props.clearFacet(FACET_CODES.CHUCK_SIZE);
      this.props.clearFacet(FACET_CODES.CHUCK_DETAIL);
    }
    this.props.clearProducts(PRODUCT_CODES.PRODUCTS);
    this.props.fetchFacet(FACET_CODES.CHUCK_TYPE, {
      manufacturer: value,
      type: null,
      size: null,
      detail: null,
      locale: this.props.locale
    });
    this.props.selectFacet(value, FACET_CODES.MANUFACTURER);
  }

  onChangeChuckType(value) {
    if (!value || value === 'unselected') {
      return;
    }
    if (this.props.selectedChuckType !== '') {
      this.props.clearFacet(FACET_CODES.CHUCK_SIZE);
      this.props.clearFacet(FACET_CODES.CHUCK_DETAIL);
    }
    this.props.clearProducts(PRODUCT_CODES.PRODUCTS);
    this.props.fetchFacet(FACET_CODES.CHUCK_SIZE, {
      manufacturer: this.props.selectedManufacturer,
      type: value,
      size: null,
      detail: null,
      locale: this.props.locale
    });
    this.props.selectFacet(value, FACET_CODES.CHUCK_TYPE);
  }

  onChangeChuckSize(value) {
    if (!value || value === 'unselected') {
      return;
    }
    if (this.props.selectedChuckSize !== '') {
      this.props.clearFacet(FACET_CODES.CHUCK_DETAIL);
    }
    this.props.clearProducts(PRODUCT_CODES.PRODUCTS);
    this.props.fetchFacet(FACET_CODES.CHUCK_DETAIL, {
      manufacturer: this.props.selectedManufacturer,
      type: this.props.selectedChuckType,
      size: value,
      detail: null,
      locale: this.props.locale
    });
    this.props.selectFacet(value, FACET_CODES.CHUCK_SIZE);
  }

  onChangeChuckDetail(value) {
    if (!value || value === 'unselected') {
      return;
    }
    this.props.clearProducts(PRODUCT_CODES.PRODUCTS);
    this.props.selectFacet(value, FACET_CODES.CHUCK_DETAIL);

    this.props.fetchProducts({
      manufacturer: this.props.selectedManufacturer,
      type: this.props.selectedChuckType,
      size: this.props.selectedChuckSize,
      detail: value,
      locale: this.props.locale
    });
  }

  onProductsSelection(selection) {
    this.props.selectProduct(selection, PRODUCT_CODES.PRODUCTS);
  }

  render() {
    return (
      <div className="row">
        {this.props.isFetching ? <LoadingIndicator /> : <span />}
        <div className="col-12 col-sm-8">
          <div className="divider" />
          <h3>Powered by SCHUNK</h3>

          <div className="row">
            <SearchInput
              label={FACET_CODES.MANUFACTURER}
              data={this.props.manufacturers}
              value={
                this.props.selectedManufacturer === ''
                  ? this.state.defaultItem.name
                  : this.props.selectedManufacturer
              }
              onChange={this.onChangeManufacturer}
            />

            <SearchInput
              label={FACET_CODES.CHUCK_TYPE}
              data={this.props.chuckTypes}
              value={
                this.props.selectedChuckType === ''
                  ? this.state.defaultItem.name
                  : this.props.selectedChuckType
              }
              onChange={this.onChangeChuckType}
              disabled={this.props.selectedManufacturer === ''}
            />

            <SearchInput
              label={FACET_CODES.CHUCK_SIZE}
              data={this.props.chuckSizes}
              value={
                this.props.selectedChuckSize === ''
                  ? this.state.defaultItem.name
                  : this.props.selectedChuckSize
              }
              onChange={this.onChangeChuckSize}
              disabled={this.props.selectedChuckType === ''}
            />

            <SearchInput
              label={FACET_CODES.CHUCK_DETAIL}
              data={this.props.chuckDetails}
              value={
                this.props.selectedChuckDetail === ''
                  ? this.state.defaultItem.name
                  : this.props.selectedChuckDetail
              }
              onChange={this.onChangeChuckDetail}
              disabled={
                this.props.selectedChuckSize === '' ||
                !this.props.chuckDetails ||
                this.props.chuckDetails.length === 0
              }
            />

            <div className="col-12 col-sm-6">
              <Button
                className="btn-secondary"
                style={{ marginTop: 15 }}
                onClick={this.resetSearch}
              >
                <Translate id="SearchForm_NewSearch" />
              </Button>
            </div>
          </div>
          <div className="divider" />
        </div>
        {(this.state.browser === undefined ||
          !(
            this.state.browser.version !== undefined &&
            this.state.browser.version.length > 0 &&
            this.state.browser.version[0] === '9' &&
            this.state.browser.name === 'ie'
          )) && (
          <div className="col-12 col-sm-4">
            <InfoBox
              heading={'InfoBox_Header'}
              text={'InfoBox_Text'}
              phone={this.props.partnerPhoneNumber}
              serviceHoursLine1={this.props.partnerServiceHoursLine1}
              serviceHoursLine2={this.props.partnerServiceHoursLine2}
            />
          </div>
        )}
        <div className="col-12 col-sm-12">
          <SearchResult
            data={this.props.products}
            hasSelectedProducts={this.props.hasSelectedProducts}
            onProductsSelection={this.onProductsSelection}
            customerType={this.props.customerType}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  manufacturers,
  chuckTypes,
  chuckSizes,
  chuckDetails,
  products,
  shopParameters,
  localize
}) {
  return {
    manufacturers: manufacturers.values,
    selectedManufacturer: manufacturers.selected,
    chuckTypes: chuckTypes.values,
    selectedChuckType: chuckTypes.selected,
    chuckSizes: chuckSizes.values,
    selectedChuckSize: chuckSizes.selected,
    chuckDetails: chuckDetails.values,
    products: products.values,
    selectedChuckDetail: chuckDetails.selected,
    customerType: shopParameters.data.customerType,
    locale: shopParameters.data.locale,
    partnerPhoneNumber: shopParameters.data.partnerServiceNumber,
    partnerServiceHoursLine1: shopParameters.data.serviceHoursLine1,
    partnerServiceHoursLine2: shopParameters.data.serviceHoursLine2,
    translate: getTranslate(localize),

    isFetching:
      manufacturers.isFetching ||
      chuckTypes.isFetching ||
      chuckSizes.isFetching ||
      chuckDetails.isFetching ||
      products.isFetching,

    hasSelectedProducts: products.hasSelectedProducts
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchManufacturers,
      fetchFacet,
      selectFacet,
      clearFacet,
      fetchProducts,
      clearProducts,
      selectProduct
    },
    dispatch
  );
}

export default withLocalize(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchForm))
);



// WEBPACK FOOTER //
// ./src/containers/SearchForm.js